import { useEffect, useState } from "react";
import axios from "axios";
import toast from "react-hot-toast";
// import { getCredentials } from "../../utils/helpers";

export default function useNin(form: any, updateFormValues: any) {
  const [ninError, setNinError] = useState<any>(null);
  const [ninUser, setNinUser] = useState<any>(null);
  const [loader, setLoader] = useState<any>(false);
  const [success, setSuccess] = useState<any>(false);

  useEffect(() => {
    setNinError(null);
    if (form?.nin) {
      if (form?.nin?.length == 14) {
        const fetchNin = async () => {
          try {
            setLoader(true);
            setNinUser(null);

            // const NIN_SERVICE_URL = `https://service.test.iras.go.ug/ura/services/validate_nin`;
            const NIN_SERVICE_URL = `https://eservices.nema.go.ug/api/services/validate-nin`;
            const response: any = await axios.get(NIN_SERVICE_URL, {
              headers: {
                "Content-Type": "application/json",
                // Authorization: `Bearer ${getCredentials()?.access}`,
              },
              params: {
                nin: form?.nin,
              },
            });
            setLoader(false);

            // Check if response has valid data with required fields
            if (
              response?.data &&
              (response.data.personGivenNames || response.data.personSurname)
            ) {
              setNinUser(response);
              setSuccess(true);
              updateFormValues({
                first_name: response.data.personGivenNames || "",
                last_name: response.data.personSurname || "",
                other_name: response.data.personOtherNames || "",
              });
            } else {
              // Response received but no valid data found
              setNinUser(null);
              setSuccess(false);
              toast.error("NIN data not found");
              updateFormValues({
                first_name: "",
                last_name: "",
                other_name: "",
              });
            }
          } catch (error) {
            setLoader(false);
            setSuccess(false);
            toast.error("NIN data not found");
            updateFormValues({
              first_name: "",
              last_name: "",
              other_name: "",
            });
          }
        };
        fetchNin();
      } else {
        updateFormValues({
          first_name: "",
          last_name: "",
          other_name: "",
        });
      }
    }
  }, [form?.nin]);

  return { ninError, loader, success, ninUser };
}
